import { render, staticRenderFns } from "./approvalWorkLeave.vue?vue&type=template&id=5ff06d45&scoped=true&"
import script from "./approvalWorkLeave.vue?vue&type=script&lang=js&"
export * from "./approvalWorkLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff06d45",
  null
  
)

export default component.exports